import React, { useEffect } from 'react';

import './App.css';

import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Unsubscribe from './Pages/Unsubscribe';
import { Signupform } from './Components/Signupform';
import Navigation from './Components/Navigation';
import Footer from './Components/Footer';
import { Membership } from './Pages/Membership';
import { About } from './Pages/About';
import { Consulting } from './Pages/Consulting';
import { LandingPage } from './Pages/LandingPage';
import ScrollToTop from './Animations/ScrollToTop';
import { SignIn } from './Pages/SignIn';
import { UserProvider } from './DataService/UserContext';
import { CartProvider } from './DataService/CartContext';
import ProtectedRoute from './Components/ProtectedRoute';
import { AdminBookings } from './Pages/AdminPages/AdminBookings';
import { NewsPage } from './Pages/AdminPages/NewsPage';
import AdminCourses from './Pages/AdminPages/AdminCourses';
import AdminPrograms from './Pages/AdminPages/AdminPrograms';
import { PrivacyPolicy } from './Pages/PrivacyPolicy';
import { TermsOfService } from './Pages/TermsOfService';
import { CookieBanner } from './Components/CookieBanner';
import ContactForm from './Components/ContactForm';
import { PaymentForm } from './Pages/PaymentForm';
import { Booking } from './Pages/Booking';
import { RotSignup } from './Pages/RotSignup';
import RotBalancePayment from './Pages/RotBalancePayment';
import { AcceptRebook } from './Pages/AcceptRebook';
import { AdminCampainTemp } from './Pages/AdminPages/AdminCampainTemp';
import { CoursePlayer } from './Pages/CoursePlayer';
import GroupsListPage from './Pages/AdminPages/AdminGroupComps/GroupsListPage';
import GroupDetailsPage from './Pages/AdminPages/AdminGroupComps/GroupDetailsPage';

import { SeminarsListPage } from './Pages/AdminPages/AdminGroupComps/SeminarsListPage';
import SendSeminarInvitesPage from './Pages/AdminPages/AdminGroupComps/SendSeminarInvitesPage';
import { Marketplace } from './Pages/MarketPlace';
import { AdminShell } from './Pages/AdminPages/AdminShell';
import { FreebieClaimPage } from './Pages/FreebieClaimPage';
import { MemberDashboard } from './Pages/MemberPages/MemberDashboard';
import { CartPage } from './Pages/CartPage';
import { OrderDetailsPage } from './Pages/MemberPages/Components/OrderDetailsPage';
import { AdminOrdersPage } from './Pages/AdminPages/AdminOrdersPage';
import { AdminPortalTools } from './Pages/AdminPages/AdminPortalTools';
import { ForgotPassword } from './Pages/ForgotPassword';
import { ResetPassword } from './Pages/ResetPassword';
import { ThemeSwitcher } from './Components/ThemeSwitcher';
import { FreebieDownloadPage } from './Pages/FreebieDownloadPage';



function App() {
//  const location = useLocation();

// useEffect(() => {
//   const params = new URLSearchParams(location.search);
//   if (params.get("sessionExpired") === "true") {
//     toast.info("Din session har gått ut. Logga in igen.", {
//       position: "top-right"
//     });
//   }
// }, [location]);

  return (
      <>
      <BrowserRouter>
      <CookieBanner/>
      <UserProvider>
      <CartProvider>
      <ScrollToTop/>
        <ThemeSwitcher />
        <PathNormalizer />
        <Routes>
          <Route path="/" element={<><Navigation/><LandingPage /><Footer/></>} />
          <Route path="/cart" element={<><Navigation/><CartPage /><Footer/></>} />
          <Route path="/payment" element={<><Navigation/><PaymentForm /><Footer/></>} />
          <Route path='/unsubscribe' element={<><Navigation/><Unsubscribe/><Footer/></>}/>
          <Route path='/rebook/accept' element={<><Navigation/><AcceptRebook/><Footer/></>}/>
          <Route path='/forgot-password' element={<><Navigation/><ForgotPassword/><Footer/></>}/>
          <Route path='/reset-password' element={<><Navigation/><ResetPassword/><Footer/></>}/>
          <Route path="/membership" element={<><Navigation/><Membership/><Footer/></>}/>
          <Route path="/membership/signup" element={<><Navigation/><Signupform/><Footer/></>}/>
          <Route path="/about" element={<><Navigation/><About/><Footer/></>}/>
          <Route path="/samtal" element={<><Navigation/><Consulting/><Footer/></>}/> 
          <Route path="/booking" element={<><Navigation/><Booking/><Footer/></>}/> 
          <Route path="/rot/signup" element={<><Navigation/><RotSignup/><Footer/></>} />
          <Route path="/rot/balance/:courseId" element={<><Navigation/><RotBalancePayment/><Footer/></>} />
          <Route path="/courses" element={<><Navigation/><Marketplace/><Footer/></>}/> 
          <Route path="/freebie/:token" element={<><Navigation/><FreebieClaimPage /><Footer/></>} />
          <Route path="/freebie/download/:downloadToken" element={<><Navigation/><FreebieDownloadPage /><Footer/></>} />
          <Route path="/privacy-policy" element={<><Navigation/><PrivacyPolicy/><Footer/></>}/>   
          <Route path="/terms-of-service" element={<><Navigation/><TermsOfService/><Footer/></>}/>  
          <Route path="/contact" element={<><Navigation/><ContactForm/><Footer/></>}/>  
          <Route path="/sign-in" element={<><Navigation/><SignIn /*user={user} userInvokeCallback={handleUserInvoke}*//><Footer/></>}/>
          <Route path="/member-home" element={<ProtectedRoute requiredRole={["member","courseowner"]}><><Navigation/><MemberDashboard/><Footer/></></ProtectedRoute>}/>
          <Route path="/member/courses/:courseId" element={<ProtectedRoute requiredRole={["member","courseowner"]}><><Navigation/><CoursePlayer/><Footer/></></ProtectedRoute>} />
          <Route path="/member/orders/:orderId" element={<ProtectedRoute requiredRole={["member","courseowner"]}><><Navigation/><OrderDetailsPage/><Footer/></></ProtectedRoute>}/>
          <Route path="*" element={<RouteFixer />} />
          {/* <Route path="/admin-home" element={<ProtectedRoute requiredRole='admin'><><Navigation/><AdminHome/><Footer/></></ProtectedRoute>}/>
          <Route path="/admin-bookings" element={<ProtectedRoute requiredRole='admin'><><Navigation/><AdminBookings/><Footer/></></ProtectedRoute>}/>
         
          <Route path="/admin-newsmail" element={<ProtectedRoute requiredRole='admin'><><Navigation/><NewsPage/><Footer/></></ProtectedRoute>}/>
          <Route path="/admin-courses" element={<ProtectedRoute requiredRole='admin'><><Navigation/><AdminCourses/><Footer/></></ProtectedRoute>}/>
          <Route path="/admin-promo-code" element={<ProtectedRoute requiredRole='admin'><><Navigation/><AdminCampainTemp/><Footer/></></ProtectedRoute>}/>
          <Route path="/admin-groups" element={<ProtectedRoute requiredRole='admin'><><Navigation/><GroupsListPage /><Footer/></></ProtectedRoute>} />
          <Route path="/admin-groups/:id" element={<ProtectedRoute requiredRole='admin'><><Navigation/><GroupDetailsPage /><Footer/></></ProtectedRoute>} />
          <Route path="/admin-seminars" element={<ProtectedRoute requiredRole='admin'><><Navigation/><SeminarsListPage /><Footer/></></ProtectedRoute>} />
          <Route path="/admin-seminars/send" element={<ProtectedRoute requiredRole='admin'><><Navigation/><SendSeminarInvitesPage /><Footer/></></ProtectedRoute>} /> */}
          <Route
  path="/admin"
  element={
    <ProtectedRoute requiredRole="admin">
      
      <><AdminShell /></>
    </ProtectedRoute>
  }
>
  <Route index element={<AdminCourses />} />
  <Route path="orders" element={<AdminOrdersPage />} />
  <Route path="orders/:orderId" element={<AdminOrdersPage />} />
  {/* <Route path="home" element={<AdminHome />} /> */}
  <Route path="courses" element={<AdminCourses />} />
  <Route path="programs" element={<AdminPrograms />} />
  <Route path="tools" element={<AdminPortalTools />} />
  <Route path="bookings" element={<AdminBookings />} />
  <Route path="groups" element={<GroupsListPage />} />
  <Route path="groups/:id" element={<GroupDetailsPage />} />
  <Route path="newsmail" element={<NewsPage />} />
  <Route path="promo-code" element={<AdminCampainTemp />} />
  <Route path="seminars" element={<SeminarsListPage />} />
  <Route path="seminars/send" element={<SendSeminarInvitesPage />} />
  <Route path="course-preview/:courseId" element={<CoursePlayer />} />
  </Route>
        </Routes>
      </CartProvider>
      </UserProvider>
      </BrowserRouter>
     </>
   
  );
}

function PathNormalizer() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.startsWith('//')) {
      const normalizedPath = `/${location.pathname.replace(/^\/+/, '')}`;
      navigate(`${normalizedPath}${location.search}${location.hash}`, { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}

function RouteFixer() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const normalizedPath = location.pathname.replace(/^\/+/, '/');
    if (normalizedPath !== location.pathname) {
      navigate(`${normalizedPath}${location.search}${location.hash}`, { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}

export default App;
